import { ReferralBonusTab } from './referral-bonus-tab';

export type ReferralBonusParticipantStatusKind = 'pending' | 'completed';

const REFERRAL_BONUS_PARTICIPANT_STATUS_BY_TAB: Record<
  ReferralBonusTab,
  ReferralBonusParticipantStatusKind
> = {
  'in-progress': 'pending',
  completed: 'completed',
};

export const REFERRAL_BONUS_STATUS_TEXT_KEY_BY_KIND: Record<
  ReferralBonusParticipantStatusKind,
  string
> = {
  pending: 'referralBonus.statusPending',
  completed: 'referralBonus.statusCompleted',
};

export function selectReferralBonusParticipantStatusKind(
  activeTab: ReferralBonusTab,
): ReferralBonusParticipantStatusKind {
  return REFERRAL_BONUS_PARTICIPANT_STATUS_BY_TAB[activeTab];
}
